var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('title-products',{attrs:{"title":"Categoria de Produtos"}}),_c('view-product-category'),_c('open-edit-product'),_c('open-delete-product'),_c('open-add-product-category'),_c('open-append-product-to-category')],1)}
var staticRenderFns = []

export { render, staticRenderFns }